import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Observable} from 'rxjs';
import {ICruisePrefetch} from '../../../shared/interfaces/icruise-prefetch';
import {WidgetService} from '../../../shared/services/widget.service';
import {MobileService} from '../../../shared/services/mobile.service';

@Component({
  selector: 'app-engine-cruise-select-harbour',
  templateUrl: './engine-cruise-select-harbour.component.html',
  styleUrls: ['./engine-cruise-select-harbour.component.scss']
})
export class EngineCruiseSelectHarbourComponent implements OnInit, OnChanges {

  public isMobile$: Observable<boolean>;
  public isWidget$: Observable<boolean>;

  constructor(private _mobileService: MobileService,
              private _widgetService: WidgetService) { }

  @Output() selectedHarbour: EventEmitter<number> = new EventEmitter<number>();
  @Input() defaultHarbour: number | string;
  @Input() cruisePrefetch$: Observable<ICruisePrefetch>;
  selectedHarbourInner: any;

  ngOnInit(): void {
    this.isMobile$ = this._mobileService.isMobile();
    this.isWidget$ = this._widgetService.isWidget();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.defaultHarbour && this.defaultHarbour) {
      this.defaultHarbour = Number(this.defaultHarbour);
      this.selectedHarbourInner = JSON.parse(JSON.stringify(this.defaultHarbour));
      this.selectedHarbour.emit(this.selectedHarbourInner);
    }
  }

  selectHarbour(harbour: any): void {
    this.selectedHarbourInner = harbour ? harbour.Id : undefined;
    this.selectedHarbour.emit(this.selectedHarbourInner);
  }

}
